import { PencilIcon } from '../../components/icons';
import { Button } from '../../components/ui';
import Header from '../../components/common/global-top-bar';
import { useState } from 'react';
import { ContentRecommendation, useContentRecommendations } from '../../hooks/useContentRecommendations';
import { ContentRecommendationsModal } from './content-recommendations-modal';

export interface ContentRecommendationModalDTO extends Partial<ContentRecommendation> {
  isNew?: boolean;
}

export const ContentRecommendationsPage = () => {
  const [current, setCurrent] = useState<ContentRecommendationModalDTO>();
  const { data: recommendations } = useContentRecommendations();

  return (
    <div>
      <Header heading="Content Recommendations" />
      <div className="my-4 flex justify-end pr-8">
        <Button
          variant="primary"
          onClick={() =>
            setCurrent({
              title: '',
              description: '',
              questions: [''],
              vertical_id: null,
              isNew: true,
            })
          }
        >
          Add Recommendation
        </Button>
      </div>
      <div className="flex justify-center px-8">
        <table className="min-w-full">
          <thead>
            <tr>
              <th className="px-2 py-2 text-left">Title</th>
              <th className="px-2 py-2 text-left">Description</th>
              <th className="px-2 py-2 text-left">Questions</th>
              <th className="px-2 py-2 text-left">Vertical</th>
              <th className="px-2 py-2 text-center">Edit</th>
            </tr>
          </thead>
          <tbody>
            {recommendations?.map((rec) => (
              <tr key={rec.id} className="border-t">
                <td className="px-2 py-3 text-left align-top font-medium">{rec.title}</td>
                <td className="max-w-md px-2 py-3 text-left align-top">{rec.description}</td>
                <td className="whitespace-nowrap px-2 py-3 text-left align-top">{(rec.questions || []).length}</td>
                <td className="px-2 py-3 text-left align-top">{rec.vertical_name ?? 'All verticals'}</td>
                <td className="px-2 py-3 text-center align-top">
                  <button type="button" onClick={() => setCurrent(rec)}>
                    <PencilIcon />
                  </button>
                </td>
              </tr>
            ))}
            {!recommendations?.length && (
              <tr>
                <td colSpan={5} className="py-8 text-center text-gray-500">
                  No content recommendations yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ContentRecommendationsModal
        key={current?.id ?? (current?.isNew ? 'new' : 'closed')}
        recommendation={current!}
        open={!!current}
        onClose={() => setCurrent(undefined)}
      />
    </div>
  );
};
